import React, { useState, useEffect, useRef } from 'react'
import { withAuth } from '../AuthContext'
import { withRouter } from 'react-router-dom'
import IframeResizer from 'iframe-resizer-react'

import styled from 'styled-components'

import { CommunityFrame } from '../Utils/CustomClasses'

const CommunitySection = styled.section`
  margin: 40px 0 0;

  @media (max-width: 991px) {
    margin: 130px 0 0;
  }

  @media (max-width: 801px) {
    margin: 153px 0 0;
  }

  @media (max-width: 767px) {
    margin: -15px 0 0;
  }
`

const Community = (props) => {
  return (
    <CommunitySection className="edit-profile">
      <iframe
        src="https://community.freebirdclub.com?automatic_login=true"
        style={{ width: '100%', height: '2000px', overflow: 'hidden' }}
      ></iframe>
    </CommunitySection>
  )
}

export default withRouter(withAuth(Community))
